export default __webpack_public_path__ + "static/media/vote.bbc4236b.png";